import { SET_LEAVES } from "./types.js";
import service from "../providers/service.js";
import { tokenize } from "../helpers/token.js";
import { setErrors } from "./error.js";

/**
 * Fetch all leaves for user by id
 * @param {number} userId 
 */
export function fetchLeavesForUser(userId) {
  return dispatch => {
    service
      .get(tokenize(`/api/leaves/${userId}`))
      .then(response => {
        dispatch(setLeaves(response.data.leaves));
      }).catch(err => {
        console.log(err);
      })
  }
}

/**
 * Update leaves for user
 * @param {number} userId 
 * @param {array} leaveData 
 */
export function updateLeaves(userId, leaveData) {
  return (dispatch) => {
    const config = { headers: { 'Content-Type': 'json' } };

    service
      .post(tokenize(`/api/leaves/update`), { leaves: leaveData }, config)
      .then(response => {
        if (response.data.message === 'leave.success') {
          dispatch(fetchLeavesForUser(userId));
          alert('Other activity data has been updated!');
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
          alert('An error has occured!');
        }
      }).catch((err) => {
        console.log(err);
      })
  };
}

/**
 * Delete leave
 * @param {number} userId 
 * @param {number} leaveId 
 */
export function deleteLeave(userId, leaveId) {
  return dispatch => {
    service
      .post(tokenize(`/api/leaves/${leaveId}/destroy`))
      .then(response => {
        if (response.data.message === 'leave.success') {
          dispatch(fetchLeavesForUser(userId))
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}

// set leave to store
export function setLeaves(leaves) {
  return {
    type: SET_LEAVES,
    leaves: leaves
  };
}


// WEBPACK FOOTER //
// ./src/actions/leave.js